import React, { useState } from "react";
import "../../Auth/Auth.css";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import Timer from "../../../components/Timer";
import { buttonText } from "../../../utils/buttonText";
import { notificationText } from "../../../utils/notificationText";
import { pageText } from "../../../utils/pageText";

function SignupForm(props) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [signuploading, setSignuploading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    let formErrors = {};

    if (!formData.username) {
      formErrors.username = "Username is required";
    }

    if (!formData.email) {
      formErrors.email = "Email is required";
    }

    if (!formData.password) {
      formErrors.password = "Password is required";
    }

    if (formData.password !== formData.confirmPassword) {
      formErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(formErrors);

    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setSignuploading(true);
      try {
        const response = await props.signupActions.userSignupRequest(formData);
        const status = response.status;
        setSignuploading(false);
        if (status === 200) {
          // Signup successful, navigate to the home page
          const successful_alert = response.data.message;
          window.alert(successful_alert);
          navigate("/signin");
        } else {
          // Signup failed, show an error message
          window.alert("Signup failed. Please try again.");
        }
      } catch (error) {
        setSignuploading(false);
        if (error.statusCode === 400) {
          window.alert(JSON.stringify(error.message));
        } else {
          // Handle any other errors
          window.alert(error.message);
        }
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="modern-signin-form">
      <div className="modern-form-title">
        <h2>{pageText("Create Account")}</h2>
      </div>

      <div className="modern-form-group">
        <label className="modern-label">{pageText("Username")}</label>
        <input
          type="text"
          name="username"
          value={formData.username}
          onChange={handleChange}
          placeholder={pageText("Enter your username")}
          className={classNames("modern-input", {
            "input-error": errors.username,
          })}
        />
        {errors.username && (
          <span className="error-message">
            {notificationText(errors.username)}
          </span>
        )}
      </div>

      <div className="modern-form-group">
        <label className="modern-label">{pageText("Email")}</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder={pageText("Enter your email")}
          className={classNames("modern-input", {
            "input-error": errors.email,
          })}
        />
        {errors.email && (
          <span className="error-message">{notificationText(errors.email)}</span>
        )}
      </div>

      <div className="modern-form-group">
        <label className="modern-label">{pageText("Password")}</label>
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          placeholder={pageText("Create a password")}
          className={classNames("modern-input", {
            "input-error": errors.password,
          })}
        />
        {errors.password && (
          <span className="error-message">
            {notificationText(errors.password)}
          </span>
        )}
      </div>

      <div className="modern-form-group">
        <label className="modern-label">{pageText("Confirm Password")}</label>
        <input
          type="password"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          placeholder={pageText("Confirm your password")}
          className={classNames("modern-input", {
            "input-error": errors.confirmPassword,
          })}
        />
        {errors.confirmPassword && (
          <span className="error-message">
            {notificationText(errors.confirmPassword)}
          </span>
        )}
      </div>

      <button
        type="submit"
        className="modern-submit-btn"
        disabled={signuploading}
      >
        {buttonText(signuploading ? (
          <span>
            <Timer loadingStates={[signuploading]} />
          </span>
        ) : (
          "Sign Up"
        ))}
      </button>

      <div className="modern-signup-link">
        {pageText("Already have an account?")} <a href="/signin">{pageText("Sign In")}</a>
      </div>
    </form>
  );
}

export default SignupForm;
